var map = {
	"./ia-001.webp": 6509,
	"./informatica-001.webp": 5902,
	"./informatica-002.webp": 8351,
	"./informatica-003.webp": 4908,
	"./informatica-004.webp": 5981,
	"./java-001.webp": 9223,
	"./javascript-001.webp": 4056,
	"./lenguajes-001.webp": 3085,
	"./lenguajes-002.webp": 8832,
	"./programacion-001.webp": 5905,
	"./programacion-002.webp": 6644,
	"./programacion-003.webp": 9655,
	"./programacion-004.webp": 6938,
	"./programacion-005.webp": 8437,
	"./programacion-006.webp": 7336,
	"./programacion-007.webp": 3787,
	"./programacion-008.webp": 2094,
	"./programacion-009.webp": 1193,
	"./programacion-010.webp": 8971,
	"./programacion-011.webp": 1592,
	"./programacion-012.webp": 7701,
	"./python-001.webp": 4933,
	"./python-002.webp": 3832,
	"./sos-001.webp": 1702,
	"./sos-002.webp": 7319,
	"./sos-003.webp": 3284,
	"./windows-001.webp": 584
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7300;